  import React, { useState, useEffect } from 'react';
  import Button from 'react-bootstrap/Button';
  import Modal from 'react-bootstrap/Modal';
  import Form from 'react-bootstrap/Form';
  import { Popover,Tabs } from 'antd';

  // import { toast, ToastContainer } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
  import '../../../pages/admin/admin_assets/css/Profile.css';
  import '../../../pages/admin/admin_assets/css/Setting.css';
  import '../../../pages/admin/admin_assets/css/UserManagement.css';
  // import three_dots from '../../pages/img/three_dots.svg';
  // import config from '../../../src/config/config.js';
  // import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import AdminTab from '../../AdminDashboard/AdminUserManagement/AdminTab.jsx';
import AccountTab from '../../AdminDashboard/AdminUserManagement/AccountTab.jsx';


  // Modal to Add New Member and Send Invite
  function MyVerticallyCenteredModal({ show, onHide }) {
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('Admin'); // default to 'Admin'
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      
    };

    return (
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className='user_management_popup'
      >
        <Modal.Body>
          <h4>Add New Member</h4>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email address <sup><i className="bi bi-asterisk" style={{color:"#DE0A0C"}}></i></sup></Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Label>Role<sup><i className="bi bi-asterisk" style={{color:"#DE0A0C"}}></i></sup></Form.Label>
            <Form.Select value={role} onChange={(e) => setRole(e.target.value)} required>
              <option value="Admin">Admin</option>
              <option value="Category Manager">Category Manager</option>
            </Form.Select>
          </Form>
        </Modal.Body>
        <Modal.Footer className='border-0'>
          <Button type="submit" disabled={isSubmitting} onClick={handleSubmit}>
            {isSubmitting ? 'Sending Invite...' : 'Send Invite'}
          </Button>
          <Button onClick={onHide}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // Popup to Confirm User Reactivation
  function ReActivate({ show, onHide, onConfirm }) {
    return (
      <Modal show={show} onHide={onHide} size="lg" backdrop="static" centered className='yes_cancel reactivate'>
        <Modal.Body>
          <div className="confirm-removal-modal">
            <div className="confirm-removal-content">
              <h4>Confirm User Reactivation</h4>
              <p>Are you sure you want to reactivate this user? They will regain full access to the platform and all associated data.</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className='border-0'>
          <Button onClick={onConfirm}>Yes, Reactivate User</Button>
          <Button onClick={onHide}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // Main UserManagement Component
  function UserManagement() {

        const [modalShow, setModalShow] = React.useState(false);
    
    const onChange = (key) => {
      console.log(key);
    };

    const items = [
      {
        key: '1',
        label: 'Admin',
        children: <AdminTab/>,
      },
      {
        key: '2',
        label: 'Account',
        children: <AccountTab/>,
      }
    ];

    return (
      <>
        <div className="mb-5 container-fluid  user_management py-0">
          <div className='user_sec d-flex justify-content-between'>
            <div className="user_manage_title mb-2 h_title">
              <h1 className='dashboard_heading px-0'>User Management</h1>
              <p className='mb-0'>Manage your members and their account permissions here</p>
            </div>

          </div>

          <Tabs defaultActiveKey="1" items={items} onChange={onChange}  />

        </div>
    {/* Add New User Modal */}
    <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          // fetchUsers={fetchUsers}  // Passing fetchUsers to update data
        />
      </>
    );
  }

  export default UserManagement;
